import * as React from 'react';
import { ISharedJourneyItem, SharedJourneyHelper, DOMHelper, EModalType, IOutput, PropertyHelper, ISharedJourney,
	IOutputValue, OutputsHelper,ComponentHelper, EComponentTypes,IValidationResponse,IValidationMessage,ModalHelper} from '../helpers';
import { SharedJourneyConfig, SharedJourneySearch } from '../components';
import { Button, ButtonType, DialogFooter, IDropdownOption } from 'office-ui-fabric-react';
import { connect } from 'react-redux';
import store from '../store/store';
import types from '../store/types';

class SharedJourneyConfigContainer extends React.Component<any, any> {

	setModalWarningMessages = (warningMessages: string[]) => {
		store.dispatch({
			type: types.SET_MODAL_WARNING_MESSAGES,
			warningMessages: warningMessages
		});
		ModalHelper.scrollToErrorDisplay();
	}
	closeDialog = (save?: boolean) => {
	
		if(save) {
			let SharedJourney: ISharedJourney = this.props.sharedJourneyConfig.SharedJourney;
			ComponentHelper.validateComponentProperties(EComponentTypes.sharedJourney.toString(), SharedJourney.ComponentId, SharedJourney.Properties,(SharedJourney.OutputValues as IOutputValue[]),null).then(
				(validationResponse: IValidationResponse) => {

					let errorMessages: string[] = validationResponse.errorMessages.map((e) => e.clientErrorMessage);
					let warningMessages: string[] = validationResponse.warningMessages.map((w) => w.clientErrorMessage);
				
					if(errorMessages.length || warningMessages.length) {
						store.dispatch({
							type: types.SET_MODAL_ERROR_MESSAGES,
							errorMessages: errorMessages
						});
						this.setModalWarningMessages(warningMessages);
						ModalHelper.scrollToErrorDisplay();
					}
					else
					{
						let journeyId = PropertyHelper.getPropertyValue(SharedJourney.Properties, 'JourneyId');
						let componentId = SharedJourney.ComponentId;
			
						store.dispatch({
							type: types.UPDATE_SHARED_JOURNEY,
							componentId: componentId,
							sharedJourney: SharedJourney
						});
			
						//remove all existing outputs associated with componentId
						store.dispatch({
							type: types.DELETE_COMPONENT_OUTPUTS,
							componentId: componentId
						});
			
						//add Shared Journey outputs
						store.dispatch({
							type: types.ADD_SHARED_JOURNEY_OUTPUTS,
							componentId: componentId,
							outputs: SharedJourney.OutputValues
						});

						store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
					}
				});
		}
		else
		{
			store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
		}
	}
	onSearchBlur = () => {

		store.dispatch({
			type: types.SET_SHARED_JOURNEY_SEARCH,
			sharedJourneyResults: [],
			searchTerm: ''
		});

	}

	updateSearchResults = (searchTerm: string) => {

		searchTerm = searchTerm || '';

		//get shared journey items from cache
		let sharedJourneyItems:ISharedJourneyItem[] = this.props.sharedJourneys;
		sharedJourneyItems = searchTerm && searchTerm.length ? 
			sharedJourneyItems.filter((s) => {
				return s.journeyName.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0;
			})
			: sharedJourneyItems;

		store.dispatch({
			type: types.SET_SHARED_JOURNEY_SEARCH,
			sharedJourneyResults: sharedJourneyItems,
			searchTerm: searchTerm,
			componentId: this.props.componentId
		});

	}

	updateOutput = (index: number, name: string): void => {
		store.dispatch({ type: types.UPDATE_SHARED_JOURNEY_OUTPUT, index: index, name: name });
	}

    outputBlur = (index: number, name: string, staticName: string, logicalName: string): void => {
		if(!(name || name.length)) {
			let newName = staticName || logicalName;
            this.updateOutput(index, newName);
		}	
	};

    updateSelectedGlobalOutput = (index:number, key: string): void => {
		store.dispatch({
			type: types.UPDATE_SHARED_JOURNEY_GLOBAL_OUTPUT, 
			index: index, 
			key: key
		});
	};

    updateSelectedOutputType = (index: number, type: number): void => {
		store.dispatch({
			type: types.UPDATE_SHARED_JOURNEY_OUTPUT_TYPE,
			index: index,
			outputType: type
		});	
	};

    updateOutputLogicalName = (index: number, logicalName: string): void => {
		store.dispatch({ 
			type: types.UPDATE_SHARED_JOURNEY_OUTPUT_LOGICAL_NAME, 
			index: index, 
			logicalName: logicalName 
		});
	};

	updateOutputDefaultValue = (index: number, defaultValue: string): void => {
        store.dispatch({
            type: types.UPDATE_SHARED_JOURNEY_OUTPUT_DEFAULT_VALUE,
            index: index,
            defaultValue: defaultValue
        });  	
	};
	
	addSharedJourneyOutput = (): void => {
		store.dispatch({
			type: types.ADD_SHARED_JOURNEY_OUTPUT
		});
	};
	
	deleteSharedJourneyOutput = (index: number): void => {
		store.dispatch({
			type: types.DELETE_SHARED_JOURNEY_OUTPUT,
			index: index
		});	
	};

	setInputValue = (outputId: string, value: string) => {
		
		let SharedJourney = this.props.sharedJourneyConfig.SharedJourney;
		let output = SharedJourney.OutputValues.filter(o => o.Id === outputId)[0];
		if(output) {
			output.InputValue = value;
		}

		store.dispatch({
			type: types.SET_SHARED_JOURNEY_CONFIG,
			sharedJourney: SharedJourney
		});

	}

    setSharedJourney = (componentId: string, journeyId: string) => {

		// clear shared journey search
		store.dispatch({
            type: types.SET_SHARED_JOURNEY_SEARCH,
            sharedJourneyResults: [],
            searchTerm: ''
        });
		
		let SharedJourney = this.props.sharedJourneyConfig.SharedJourney;
		SharedJourney = PropertyHelper.updateProperty(SharedJourney, 'JourneyId', journeyId);

		// set the selected shared journey and outputs for the sharedJourneyConfig state
		if(journeyId && journeyId.length) {

			store.dispatch({
				type: types.SET_MODAL_OVERLAY_MESSAGE,
				overlayMessage: 'Loading...'
			});

			SharedJourneyHelper.getSharedJourneyOutputs(journeyId).then(
				(outputs: IOutput[]) => {

					SharedJourney.OutputValues = outputs;

					store.dispatch({
						type: types.SET_SHARED_JOURNEY_CONFIG,
						sharedJourney: SharedJourney
					});

					store.dispatch({
						type: types.SET_MODAL_OVERLAY_MESSAGE,
						overlayMessage: null
					});

				}
				
			);

		}
		else {

			SharedJourney.OutputValues = null;

			store.dispatch({
				type: types.SET_SHARED_JOURNEY_CONFIG,
				sharedJourney: SharedJourney
			});			

		}

    }

	public render() {

		let SharedJourney = this.props.sharedJourneyConfig.SharedJourney;
		let { sharedJourneyResults, sharedJourneyTerm } = this.props.searchState;

		let journeyId = PropertyHelper.getPropertyValue(SharedJourney.Properties, 'JourneyId');

		let sharedJourneyName:string = journeyId && journeyId.length ? SharedJourneyHelper.getSharedJourneyName(journeyId) : null;

		let outputOptions: IDropdownOption[] = OutputsHelper.getOutputDropdownOptions(this.props.outputs, this.props.sharedJourneyConfig.previousOutputBlocks, SharedJourney.ComponentId);
		let globalOutputDropdownOptions: IDropdownOption[] = OutputsHelper.getGlobalOutputDropdownOptions(this.props.outputs);

		return (
			<div>
				<div className="shared-journey-config-wrapper">
					<SharedJourneySearch
						componentId={ SharedJourney.ComponentId }
						journeyId={ journeyId }
						journeyName={ sharedJourneyName }
						setSharedJourney={ this.setSharedJourney }
						updateSearchResults={ this.updateSearchResults }
						onSearchBlur={ this.onSearchBlur }
						sharedJourneyResults={ sharedJourneyResults }
						sharedJourneyTerm={ sharedJourneyTerm }			
					/>			
					<SharedJourneyConfig 
						outputs={ SharedJourney.OutputValues }
						outputOptions={ outputOptions }
						globalOutputDropdownOptions={ globalOutputDropdownOptions }
						sharedJourneyId={ journeyId }

						updateOutput={ this.updateOutput }
						outputBlur={ this.outputBlur }
						updateSelectedGlobalOutput={ this.updateSelectedGlobalOutput }
						updateSelectedOutputType={ this.updateSelectedOutputType }
						updateOutputLogicalName={ this.updateOutputLogicalName }
						updateOutputDefaultValue={ this.updateOutputDefaultValue }
						addSharedJourneyOutput={ this.addSharedJourneyOutput }
						deleteSharedJourneyOutput={ this.deleteSharedJourneyOutput }			
						setInputValue={ this.setInputValue }
					/>
				</div>
				<DialogFooter>
					<Button tabIndex={1001} buttonType={ ButtonType.normal } onClick={ () => this.closeDialog(false) }>Cancel</Button>
					<Button tabIndex={1002} buttonType={ ButtonType.primary }
						disabled={ !(journeyId && journeyId.length) }
						onBlur={ () => { DOMHelper.focusOnFirstModalTabbableControl(); } }
						onClick={ () => this.closeDialog(true) }>Save</Button>
				</DialogFooter>	
			</div>		
		);

	}

}

let mapStateToProps = (store) => {

	let outputs: IOutputValue[] = OutputsHelper.CombineOutputs(store.outputsState.outputs, store.outputsState.globalOutputs);

	return {
		searchState: store.searchState,
		sharedJourneyConfig: store.modalState.sharedJourneyConfig,
		sharedJourneys: store.cacheState.sharedJourneys,
		outputs: outputs
	};
};

export default connect<any, any, any>(mapStateToProps)(SharedJourneyConfigContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/shared-journey-config.tsx